<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid" style="margin-top: 20px;">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">COURSE</h4>
            </div>
        </div>

        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>

        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Type Of Course</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Approval Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let coursedata of coursedatas">
                            <td style="min-width: 20px;">
                                {{coursedata.course_name}}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.course_des}}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.typeofcourse}}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.course_date | date: 'dd-MM-yyyy'}}
                            </td>
                            <td style="min-width: 20px;">
                                {{coursedata.course_time}}
                            </td>
                            <td>
                                <!-- <button 
                                    [ngClass]="coursedata.allow_course === '1' ? 'btn btn-success' : 'btn btn-danger'" 
                                    data-toggle="modal" 
                                    data-target="#myModal" 
                                    (click)="onSelectCourse(coursedata)">
                                    {{ coursedata.allow_course === '1' ? 'Approved' : 'Not Approved' }}
                                </button> -->
                                <button 
                                [ngClass]="coursedata.allow_course === '1' ? 'btn btn-success': (coursedata.allow_course === '0' ? 'btn btn-danger' : 'btn btn-info')"
                                data-toggle="modal" 
                                data-target="#myModal" 
                                (click)="onSelectCourse(coursedata)">
                                {{ coursedata.allow_course === '1' ? 'Approved' : (coursedata.allow_course === '0' ? 'Rejected' : 'Open') }}
                            </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card-header show-header">
                        <h3 class="card-title">APPROVED COURSE</h3>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form [formGroup]="mentorcourse"  enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="mentor_name">Mentor Name</label>
                                    <input type="text" id="mentor_name" formControlName="mentor_name" class="form-control" readonly>
                                </div>
                                <div class="col-md-6">
                                    <label for="mentor_number">Mentor Phone No</label>
                                    <input type="text" id="mentor_number" formControlName="mentor_number" class="form-control" readonly>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="mentor_email">Mentor Email</label>
                                    <input type="text" id="mentor_email" formControlName="mentor_email" class="form-control" readonly>
                                </div>
                                <div class="col-md-6">
                                    <label for="mentor_district">Mentor District</label>
                                    <input type="text" id="mentor_district" formControlName="mentor_district" class="form-control" readonly>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="course_name">Course Name</label>
                                    <input type="text" id="course_name" formControlName="course_name" class="form-control" readonly>
                                </div>
                                <div class="col-md-6">
                                    <label for="course_topic">Course Topic</label>
                                    <input type="text" id="course_topic" formControlName="course_topic" class="form-control" readonly>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="course_des">Description</label>
                                    <textarea id="course_des" formControlName="course_des" class="form-control" readonly></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="course_date">Course Date</label>
                                    <input id="course_date" formControlName="course_date" class="form-control" readonly>
                                </div>
                                <div class="col-md-6">
                                    <label for="course_time">Course Time</label>
                                    <input id="course_time" formControlName="course_time" class="form-control" readonly>
                                </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                       
                                        <label for="online_meet_link">Online Meeting Link</label>
                                        <input id="online_meet_link" formControlName="online_meet_link" class="form-control" (click)="copyToClipboard()">
                                   
                                    <small id="copyMessage" style="display:none; color: green;">Link copied to clipboard!</small>
                                    </div>
                                     <div class="col-md-6">
                                        <label>Photo <span class="required">*</span></label>
                                        <input type="file" formControlName="image" id="file"  class="form-control" (change)="selectFiles($event)" />
                                        <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format jpeg, jpg, png</p>
                                    
                                        <!-- Display the selected image or a default image if none is selected -->
                                        <!-- <img [src]="imageSrc || 'images/course.jpg'" 
                                             style="width:100px;height:100px;display:block;margin-top:10px;" 
                                             alt="Course Image"/> -->
                                             
                                        <div style="color:red;" 
                                             *ngIf="mentorcourse.get('image')?.touched && (mentorcourse.get('image')?.hasError('required') || mentorcourse.get('image')?.hasError('imageSizeExceeded'))">
                                            Please upload a valid image 
                                        </div>
                                    </div>
                                    
                                </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="comments">Comments</label>
                                    <textarea id="comments" formControlName="comments" class="form-control" readonly></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-right">
                                    <div class="modal-footer">
                                            <button type="submit" class="btn btn-primary" (click)="approveCourse()">Approve</button>
                                            <button type="button" class="btn btn-danger" (click)="rejectCourse()">Reject</button>
                                    </div>
                                </div>
                            </div>                            
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
